import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ztdgl",
  "use": "icon-ztdgl-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-ztdgl\">\r\n<path d=\"M0.2,6.3h19.7V2.9c0-1.1-0.9-2-2-2c0,0,0,0,0,0H2.1c-1.1,0-2,0.9-2,2C0.2,2.9,0.2,6.3,0.2,6.3z M18.9,17.2v-10H1v10\r\n\tc0,1,0.9,1.9,2,1.9h14C18.1,19.1,18.9,18.2,18.9,17.2L18.9,17.2L18.9,17.2z M6.9,9.3h6.3v2.7H6.9L6.9,9.3L6.9,9.3L6.9,9.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol